import {buildEventURL} from '@/utils/urlBuilder';

export const getEventEvaluationUrl = (eventId: number | string, query: string = ''): string => {
    return `${buildEventURL('evaluationList', eventId)}?query=${query}`;
};